import React, { FC } from 'react';
import { Start, Stop, Svg } from './styles';

const Close: FC<SVGIconProps> = ({ linearGradient, size = 48 }) => (
  <Svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path
      d="M50.3333 16.76L46.5733 13L31.6667 27.9067L16.76 13L13 16.76L27.9067 31.6667L13 46.5733L16.76 50.3333L31.6667 35.4267L46.5733 50.3333L50.3333 46.5733L35.4267 31.6667L50.3333 16.76Z"
      fill="url(#paint0_linear_413_127)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_413_127"
        x1="31.6668"
        y1="-5.5606"
        x2="40.5759"
        y2="53.303"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Close;
